export enum TypeCourse {
  VIDEO,
  PDF,
  PPT,
}
